import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

import { MainHeaderSearchFormComponentGeneric} from '@signature-it/ngx-generic/components/search-form';

@Component({
    selector: 'main-header-search-form',
    templateUrl: './search-form.html',
    styleUrls: ['./search-form.scss'],
    standalone: false
})
export class MainHeaderSearchFormComponent extends MainHeaderSearchFormComponentGeneric {

    dialogRef: MatDialogRef<any>;

    constructor(public dialog: MatDialog, private translate: TranslateService) {
        super();
    }


    openDialog(tpl) {
        this.dialogRef = this.dialog.open(tpl,
            {
                panelClass: 'searchBarDialogPanel',
                position: {
                    top: '0',
                    left: '0'
                },
                maxWidth: '100%',
                width: '100%',
                ariaLabel: this.translate.instant('Search bar zone')
            });
    }

    closeDialog(tpl) {
        this.dialogRef.close(tpl);
    }

}
